<aside>
  <header class="h-[64px] shadow-sm p-4 mb-[40px]">
    <app-logo [config]="{ src: '/img/trackstream-logo.svg', alt: 'TrackStream Logo', url: '/' }"></app-logo>
  </header>

  <div class="sections flex-1">
    @for (section of sections(); track section.title) {
      <section class="p-[16px] menu-section">
        @if(section.title) {
          <h2 class="mb-[10px] px-[16px] font-extrabold">{{ section.title }}</h2>
        }
        <div class="flex flex-col gap-0">
          @for (item of section.items; track item.title; let i = $index) {
            <a [attr.data-testid]="item.dataTestId" [routerLink]="item.routerLink" routerLinkActive="active" class="navigation-item">
              <span class="nav-icon" [innerHTML]="getIconTemplate(item.icon)"></span>
              <span class="capitalize">{{ item.title.toLowerCase() }}</span>
            </a>
          }
        </div>
      </section>
    }

  </div>

  <section class="p-[16px] flex flex-col gap-0">
    @defer (when isLoggedIn()) {
      <div class="custom-org-switcher" style="margin-bottom: 0; display: block;">
        <app-org-switcher class="mb-0 sidebar-org-switcher"></app-org-switcher>
      </div>
    }
    <a class="navigation-item sign-out-item" (click)="logout()">
      <img [src]="logoutSvgDataUri" alt="Logout" class="nav-icon">
      <span class="capitalize">Sign out</span>
    </a>
  </section>
</aside>
